import {actionTypes} from '../actions';

export const initial_state = {
  company: null,
  is_company_car: null,
  is_lease: null,
  lessor: null,
  is_fleet: null,
  fleet: null,
  car_repair_type_id: null,
  license: null,
  mileage: null,
  initials: null,
  firstName: null,
  lastName: null,
  email: null,
  phone_number: null,
  date: null,
  comment: null,
  replacement: null,
  services: null,
  apkSelected: null,
  categories: null,
  pickup_location: null,
  hide_denied_dialog: false,
};

export const reducer = (sessionState, action) => {
  const {type, value} = action;
  switch (type) {
    case actionTypes.INIT: {
      return {
        ...sessionState,
        ...value,
      };
    }

    case actionTypes.SET_DEALER: {
      return {
        ...sessionState,
        dealer: value,
      };
    }

    case actionTypes.ADD_JOB_SET_IS_LEASE: {
      return {
        ...sessionState,
        is_lease: value,
      };
    }

    case actionTypes.ADD_JOB_SET_LESSOR: {
      return {
        ...sessionState,
        lessor: value,
      };
    }

    case actionTypes.ADD_JOB_SET_IS_FLEET: {
      return {
        ...sessionState,
        is_fleet: value,
      };
    }

    case actionTypes.ADD_JOB_SET_CAR_REPAIR_TYPE_ID: {
      return {
        ...sessionState,
        car_repair_type_id: value,
      };
    }

    case actionTypes.ADD_JOB_SET_LICENSE: {
      return {
        ...sessionState,
        license: value,
      };
    }

    case actionTypes.ADD_JOB_SET_MILEAGE: {
      return {
        ...sessionState,
        mileage: value,
      };
    }

    case actionTypes.ADD_JOB_SET_INITIALS: {
      return {
        ...sessionState,
        initials: value,
      };
    }

    case actionTypes.ADD_JOB_SET_FIRST_NAME: {
      return {
        ...sessionState,
        firstName: value,
      };
    }

    case actionTypes.ADD_JOB_SET_LAST_NAME: {
      return {
        ...sessionState,
        lastName: value,
      };
    }

    case actionTypes.ADD_JOB_SET_EMAIL: {
      return {
        ...sessionState,
        email: value,
      };
    }

    case actionTypes.ADD_JOB_SET_PHONE: {
      return {
        ...sessionState,
        phone_number: value,
      };
    }

    case actionTypes.ADD_JOB_SET_CATEGORIES: {
      return {
        ...sessionState,
        categories: value,
      };
    }

    case actionTypes.ADD_JOB_SET_SERVICES: {
      return {
        ...sessionState,
        services: value,
      };
    }

    case actionTypes.ADD_JOB_SET_REPLACEMENT: {
      return {
        ...sessionState,
        replacement: value,
      };
    }

    case actionTypes.ADD_JOB_SET_PICKUP_LOCATION: {
      return {
        ...sessionState,
        pickup_location: value,
      };
    }

    case actionTypes.ADD_JOB_SET_APK: {
      return {
        ...sessionState,
        apkSelected: value,
      };
    }

    case actionTypes.ADD_JOB_SET_DATE: {
      return {
        ...sessionState,
        date: value,
      };
    }

    case actionTypes.ADD_JOB_SET_COMMENT: {
      return {
        ...sessionState,
        comment: value,
      };
    }

    case actionTypes.ADD_JOB_SET_COMPANY_CAR: {
      return {
        ...sessionState,
        is_company_car: value,
        company: !value ? null : sessionState.company,
      };
    }

    case actionTypes.ADD_JOB_SET_COMPANY: {
      return {
        ...sessionState,
        company: value,
      };
    }

    case actionTypes.ADD_JOB_RESET: {
      const {hard, init} = value ?? {};

      let hardReset = {};
      if (hard) {
        hardReset = {
          is_lease: null,
          is_company_car: null,
          lessor: null,
          company: null,
          hide_denied_dialog: false,
        };
      }

      return {
        ...sessionState,
        ...initial_state,
        ...hardReset,
        ...(init ?? {}),
      };
    }

    case actionTypes.TOGGLE_DENIED_DIALOG: {
      return {
        ...sessionState,
        hide_denied_dialog: !sessionState.hide_denied_dialog,
      };
    }

    default: {
      return sessionState;
    }
  }
};
